<template>
  <v-container fluid>
    <V-row>
      <v-col md="12">
        <SettingItem
          @loadData="loadData"
          collection="currency"
          :items="currency"
          :itemHeader="currencyItemHeader"
        />
      </v-col>
    </V-row>
  </v-container>
</template>

<script>
import SettingItem from "./SettingItem/index";
import ApiService from "@/services/api.service";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    SettingItem,
  },
  data() {
    return {
      currency: [],
      currencyItemHeader: [
        { text: "Title", value: "english_title" },
        { text: "from kuwaiti dinar", value: "from" },
        { text: "to kuwaiti dinar", value: "to" },
        { text: "", value: "title" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    async loadData() {
      try {
        this.loading = true;
        this.fetchData();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchData() {
      try {
        // await this.getCurrency();
        const data = await ApiService.get(
          "items/currency?fields=id,arabic_title,english_title,title,image,from,to"
        );
        this.currency = data.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.fetchData(undefined);
  },
};
</script>

<style></style>
